import { Link, useSearchParams } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function BetalingMislukt() {
  const [params] = useSearchParams();
  const checkId = params.get("check");

  return (
    <div className="py-24" data-testid="payment-failed-page">
      <div className="max-w-xl mx-auto px-6 text-center">
        <div className="h-20 w-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
          <AlertTriangle className="h-10 w-10 text-amber-600" />
        </div>
        <h1 className="font-display text-4xl font-bold text-ink mt-6 tracking-tight">
          Betaling niet voltooid
        </h1>
        <p className="text-ink-soft mt-3">
          Je betaling werd geannuleerd of mislukt. Je bent niets verschuldigd en je document werd niet geanalyseerd.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white font-semibold">
            Terug naar home
          </Link>
          <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white border border-border text-ink font-semibold">
            Hulp nodig?
          </Link>
        </div>
        {checkId && <p className="text-xs text-ink-subtle mt-6">Referentie: {checkId.slice(0, 8)}</p>}
      </div>
    </div>
  );
}
